import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_URLS } from "./apis/urls";
import Api from "./utils/apiCall";

interface WingDesignationDepartmentState {
  data: any;
  loading: "idle" | "pending" | "fulfilled" | "rejected";
  error: string | null;
  action: "list" | null;
}

const initialState: WingDesignationDepartmentState = {
  data: null,
  loading: "idle",
  error: null,
  action: null,
};

export const getWingDesignationDepartment: any = createAsyncThunk(
  "list",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(API_URLS.MASTERS.WING_DESIGNATIONS_DEPARTMENTS, payload);
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

const wingDesignationDepartmentSlice = createSlice({
  name: "reset",
  initialState: initialState,
  reducers: {
    resetAll: (state: any) => {
      state.loading = "idle";
      state.error = null;
      state.leaveTypes = null;
      state.action = null;
    },
  },
  extraReducers: (builder) => {

    builder.addCase(getWingDesignationDepartment.pending, (state) => {
      state.loading = "pending";
      state.data = null;
      state.error = null;
      state.action = "list";
    });
    builder.addCase(getWingDesignationDepartment.fulfilled, (state, action) => {
      state.loading = "fulfilled";
      state.data = action.payload;
      state.error = null;
      state.action = "list";
    });
    builder.addCase(getWingDesignationDepartment.rejected, (state, action) => {
      state.loading = "rejected";
      state.error = action.payload as string;
      state.data = null;
      state.action = "list";
    });
  },
});

export const { resetAll } = wingDesignationDepartmentSlice.actions;
export default wingDesignationDepartmentSlice.reducer;
